import SucVerticalTableComponent from "@/components/table/vertical-build/SucVerticalTableComponent.vue";
import Column from "@/components/table/vertical-build/data/column";
import Cell from "@/components/table/vertical-build/data/cell";
import Header from "@/components/table/vertical-build/data/header";

export { Column, Cell, Header, SucVerticalTableComponent as default };
